module.exports = __webpack_public_path__ + "static/media/book_wire.40eb2b0b.png";